/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useContext, useEffect } from 'react'
import 'normalize.css'
import { useStaticQuery, graphql } from 'gatsby'
import Navbar from './UI/Navbar'
import { ThemeProvider } from '@material-ui/core/styles'
import theme from './UI/Theme'
import lighttheme from './UI/LightTheme'
import FontContext from '../context/fontsize/fontContext'
// import { GatsbyContext } from '../context/context'

const Layout = ({ children }) => {
	const fontContext = useContext(FontContext)
	const { darkMode, setDarkMode, setFontSize } = fontContext

	const data = useStaticQuery(graphql`
		query SiteTitleQuery {
			site {
				siteMetadata {
					title
					twitURL
					igURL
					fbURL
				}
			}
		}
	`)
	let { title, igURL, fbURL, twitURL } = data.site.siteMetadata

	useEffect(() => {
		const theme = localStorage.getItem('preferred-theme')
		if (theme) {
			const themePreference = localStorage.getItem('preferred-theme')
			if (themePreference === 'dark') {
				setDarkMode(true)
			} else {
				setDarkMode(false)
			}
		} else {
			localStorage.setItem('preferred-theme', 'dark')
			setDarkMode(true)
		}

		const font = localStorage.getItem('preferred-font-size')
		if (font) {
			if (font === '1.1') {
				setFontSize('1.1rem', 0)
			} else if (font === '1.19') {
				setFontSize('1.19rem', 25)
			} else if (font === '1.37') {
				setFontSize('1.37rem', 50)
			} else if (font === '1.55') {
				setFontSize('1.55rem', 75)
			} else if (font === '1.75') {
				setFontSize('1.75rem', 100)
			}
		}
		//eslint-disable-next-line
	}, [])

	return (
		<ThemeProvider theme={darkMode ? theme : lighttheme}>
			{/* <ThemeProvider theme={theme}> */}
			<Navbar title={title} fbURL={fbURL} igURL={igURL} twitURL={twitURL}>
				{children}
			</Navbar>
		</ThemeProvider>
	)
}

export default Layout
